export default "__VITE_ASSET__IDItIWSR__"